import React from 'react'
import theme from '../../../themes/dark-theme'

function TransferToPayout({ transferAmount, setTransferAmount, handleTransfer, isTransferring, transferError, transferSuccess, isTestPartner }) {
  return (
    <div className="rounded-lg p-5 mt-8" style={{ color: "#d2d2d2", backgroundColor: theme.colors.background.secondary }}>
    <h3 className="text-lg font-bold mb-4">Transfer to Pay-Out Account</h3>
    {isTestPartner ? (
      <div className="text-center py-4 text-gray-400 text-sm">
        <p>Fund transfers are not permitted for test accounts.</p>
        <p className="text-xs mt-2">Contact your administrator for assistance.</p>
      </div>
    ) : (
      <>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Amount (₦)</label>
            <input
              type="number"
              value={transferAmount}
              onChange={(e) => setTransferAmount(e.target.value)}
              className="w-full p-2 rounded border"
              style={{ backgroundColor: theme.colors.background.primary, borderColor: "#0a0d15" }}
              placeholder="Enter amount"
            />
          </div>
          <div className="flex items-end">
            <button
              onClick={handleTransfer}
              disabled={isTransferring}
              className="w-full p-2 rounded text-white font-medium"
              style={{ backgroundColor: isTransferring ? "#4a5568" : "#0a0d15" }}
            >
              {isTransferring ? "Processing..." : "Transfer Funds"}
            </button>
          </div>
        </div>
        {transferError && (
          <div className="mt-2 text-red-500 text-sm">{transferError}</div>
        )}
        {transferSuccess && (
          <div className="mt-2 text-green-500 text-sm">{transferSuccess}</div>
        )}
        <div className="mt-2 text-xs text-gray-400">
          Note: Transfers are processed instantly. Ensure account details are correct.
        </div>
      </>
    )}
  </div>
  )
}

export default TransferToPayout